module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "10"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n            ")], 1)], 1), _vm._v(" "), _c('h5', {
    staticClass: "mt-1 mr-2"
  }, [_vm._v("\n            " + _vm._s(_vm.$route.name) + "\n          ")])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "1"
    }
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": function($event) {
        _vm.showCheckboxes = !_vm.showCheckboxes
      }
    }
  }, [_vm._v("\n            Columns\n          ")])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "1"
    }
  }, [_c('h5', [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.data.length) + " Entries")]) : _vm._e()])]), _vm._v(" "), _vm._l((_vm.formattedColumnHeaders), function(option) {
    return (_vm.showCheckboxes) ? _c('b-col', {
      key: option.value,
      attrs: {
        "md": "2"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedColumns),
        expression: "selectedColumns"
      }],
      attrs: {
        "type": "checkbox",
        "id": option.value
      },
      domProps: {
        "value": option.value,
        "checked": Array.isArray(_vm.selectedColumns) ? _vm._i(_vm.selectedColumns, option.value) > -1 : (_vm.selectedColumns)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.selectedColumns,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = option.value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedColumns = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedColumns = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedColumns = $$c
          }
        }, _vm.applySelectedColumns]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": option.value
      }
    }, [_vm._v(_vm._s(option.text))])]) : _vm._e()
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('label', [_vm._v("SpreadSheet ID"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "spreadsheetId"
    },
    on: {
      "input": function($event) {
        _vm.fetchData()
      }
    },
    model: {
      value: (_vm.spreadsheetId),
      callback: function($$v) {
        _vm.spreadsheetId = $$v
      },
      expression: "spreadsheetId"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain gutr"
  }, [_c('div', {
    ref: "spreadsheetContainer",
    attrs: {
      "id": "spreadsheet"
    }
  })])], 1)], 2)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20bfddbc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/common/Spreadsheet.vue
// module id = 2449
// module chunks = 0